module.exports = __webpack_public_path__ + "static/10-714493d4434e492c41fc3ac20a4fada0.jpg";